export default Object.freeze({
  woman: 'woman',
  man: 'man',
  child: 'child',
});
